import { SupportLink } from 'components/support-link';
import Warning from 'components/icons/warning';
import Message from 'components/message';

import style from './custom-error.module.scss';

export const CustomError = () => (
  <>
    <Warning className={style.Icon} />
    <h3 className={style.Header}>
      <Message id="Something went wrong" comment="Error message title" />
    </h3>
    <div className={style.Contact}>
      <SupportLink />
    </div>
  </>
);
